import {
  Button,
  Checkbox,
  FormControlLabel,
  Select,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ReactComponent as SearchIcon } from '../../../assets/images/Search.svg';
import { ExpandMore } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useHook as manufactureUnitHook } from './useHook';
import { useHook as EquipmentsDashboard } from '../hardware/equipments/useHook';
interface FilterDrawer {
  fliterCloseDrawer: () => void;
  filterSubmit: (data: any) => void;
  filterDrawerData?: any;
}

const FilterDrawer: React.FC<FilterDrawer> = ({
  fliterCloseDrawer,
  filterSubmit,
  filterDrawerData,
}) => {
  const { allCategory } = useSelector((state: any) => state.equipments);
  const { fetchGetUnitFilter } = manufactureUnitHook();
  const { fetchGetListCategory, fetchDealerGetListCategory } =
    EquipmentsDashboard();
  const { unitFilter } = useSelector((state: any) => state.manufactureUnit);
  const [dealerName, setDealerName] = React.useState<string[]>([]);
  const [dealerCategory, setDealerCategory] = React.useState<string[]>([]);
  const [dealerSubcategory, setDealerSubcategory] = React.useState<string[]>(
    [],
  );
  const [serialNumber, setSerialNumber] = React.useState<string[]>([]);
  const [filteredEquipment, setFilteredEquipment] = useState<any[]>([]);
  const [filteredCategory, setFilteredCategory] = useState<any[]>([]);
  const [filteredSubCategory, setFilteredSubCategory] = useState<any[]>([]);
  const [filteredSerialNumber, setFilteredSerialNumber] = useState<any[]>([]);
  const [isFilterActive, setFilterActive] = useState(false);
  const [filterStoreCategory, setFilterStoreCategory] = useState<any[]>([]);
  const [filterStoreSubCategory, setFilterStoreSubCategory] = useState<any[]>(
    [],
  );

  //get Category
  const handleGetCategory = () => {
    const updateCategory = allCategory?.map(
      (data: { categoryName: any }) => data?.categoryName,
    );
    setFilteredCategory(updateCategory ? updateCategory : []);
    setFilterStoreCategory(updateCategory ? updateCategory : []);
  };
  //get SubCategory
  const handleGetSubCategory = async () => {
    // Filter based on exact match for the category name
    const upDateSubCategory = allCategory
      .filter(
        (category: { categoryName: any; subCategories: any }) =>
          dealerCategory.includes(category.categoryName) &&
          Array.isArray(category.subCategories),
      )
      .flatMap((category: { subCategories: any }) => category.subCategories);
    setFilteredSubCategory(upDateSubCategory ? upDateSubCategory : []);
    setFilterStoreSubCategory(upDateSubCategory ? upDateSubCategory : []);

    //subCategory selection values
    const selectSubCategory = upDateSubCategory?.filter((data: string) =>
      dealerSubcategory?.includes(data),
    );
    setDealerSubcategory(selectSubCategory ? selectSubCategory : []);
  };

  useEffect(() => {
    handleGetSubCategory();
  }, [dealerCategory]);

  useEffect(() => {
    if (allCategory?.length > 0) {
      handleGetCategory();
    }
  }, [allCategory]);

  //setSelectionFilter
  useEffect(() => {
    if (filterDrawerData) {
      setDealerName(filterDrawerData?.equipment);
      setDealerSubcategory(filterDrawerData?.subCategory);
      setDealerCategory(filterDrawerData?.category);
      setSerialNumber(filterDrawerData?.serialNumber);
    }
  }, [filterDrawerData]);

  useEffect(() => {
    const isFilterActive =
      dealerName?.length > 0 ||
      serialNumber?.length > 0 ||
      dealerCategory?.length > 0 ||
      dealerSubcategory?.length > 0;

    setFilterActive(isFilterActive);
  }, [dealerName, serialNumber, dealerCategory, dealerSubcategory]);

  const handleSubmit = () => {
    const payload = {
      equipment: dealerName,
      serialNumber: serialNumber,
      category: dealerCategory,
      subCategory: dealerSubcategory,
    };
    filterSubmit(payload);
  };

  useEffect(() => {
    if (Object.keys(unitFilter).length === 0) {
      fetchGetUnitFilter();
    }
    if (!(allCategory?.length > 0)) {
      fetchGetListCategory({});
    }
  }, []);

  useEffect(() => {
    setFilteredEquipment(unitFilter?.equipment ? unitFilter?.equipment : []);
    setFilteredSerialNumber(
      unitFilter?.serialNumber ? unitFilter?.serialNumber : [],
    );
    // setFilteredCategory(unitFilter?.category ? unitFilter?.category : []);
    // setFilteredSubCategory(
    //   unitFilter?.subCategory ? unitFilter?.subCategory : [],
    // );
  }, [unitFilter]);

  const handleEquipmentSearch = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const query = event.target.value.toLowerCase();
    const filtered = unitFilter?.equipment?.filter((equipment: string) =>
      equipment?.toLowerCase().includes(query),
    );
    setFilteredEquipment(filtered);
  };

  const handleSerialNumberSearch = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const query = event.target.value.toLowerCase();
    const filtered = unitFilter?.serialNumber?.filter((serialNumber: string) =>
      serialNumber?.toLowerCase().includes(query),
    );
    setFilteredSerialNumber(filtered);
  };

  const handleCategorySearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value.toLowerCase();
    const filtered = filterStoreCategory?.filter((category: string) =>
      category?.toLowerCase().includes(query),
    );
    setFilteredCategory(filtered);
  };
  const handleSubCategorySearch = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const query = event.target.value.toLowerCase();
    const filtered = filterStoreSubCategory?.filter((category: string) =>
      category?.toLowerCase().includes(query),
    );
    setFilteredSubCategory(filtered);
  };

  const handleFilterSelection = (
    selectName: string | undefined,
    field: string,
  ) => {
    if (!selectName) return;
    if (field === 'equipment') {
      setDealerName((prevselected) => {
        if (prevselected.includes(selectName)) {
          const updatedData = prevselected.filter(
            (names) => names !== selectName,
          );
          return updatedData;
        } else {
          const updatedData = [...prevselected, selectName];
          return updatedData;
        }
      });
    } else if (field === 'category') {
      setDealerCategory((prevselected) => {
        if (prevselected.includes(selectName)) {
          const updatedData = prevselected.filter(
            (names) => names !== selectName,
          );
          return updatedData;
        } else {
          const updatedData = [...prevselected, selectName];
          return updatedData;
        }
      });
    } else if (field === 'subCategory') {
      setDealerSubcategory((prevselected) => {
        if (prevselected.includes(selectName)) {
          const updatedData = prevselected.filter(
            (names) => names !== selectName,
          );
          return updatedData;
        } else {
          const updatedData = [...prevselected, selectName];
          return updatedData;
        }
      });
    } else if (field === 'serialNumber') {
      setSerialNumber((prevselected) => {
        if (prevselected.includes(selectName)) {
          const updatedData = prevselected.filter(
            (names) => names !== selectName,
          );
          return updatedData;
        } else {
          const updatedData = [...prevselected, selectName];
          return updatedData;
        }
      });
    }
  };

  return (
    <div className="fliter-drawer-container">
      <div>
        <div className="fliter-drawer-header">
          <p className="fliter-drawer-header-content">Fliters</p>
          {/* <p className="fliter-drawer-header-text">Restore</p> */}
        </div>
        <div className="fliter-drawer-body">
          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Equipment</p>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              displayEmpty
              value={dealerName}
              onClose={() => setFilteredEquipment(unitFilter?.equipment)}
              renderValue={() => {
                if (dealerName.length === 0) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Equipment
                    </span>
                  );
                }
                return dealerName.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search Equipment"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={handleEquipmentSearch}
                  />
                </div>
                <div className="selectoption_list_content">
                  {filteredEquipment?.map((equipment, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={dealerName.includes(String(equipment))}
                            onChange={() => {
                              handleFilterSelection(
                                String(equipment),
                                'equipment',
                              );
                            }}
                          />
                        }
                        label={equipment}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>
          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Serial Number</p>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              displayEmpty
              value={serialNumber}
              onClose={() => setFilteredSerialNumber(unitFilter?.serialNumber)}
              renderValue={() => {
                if (serialNumber.length === 0) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Serial Number
                    </span>
                  );
                }
                return serialNumber.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search Serial Number"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={handleSerialNumberSearch}
                  />
                </div>
                <div className="selectoption_list_content">
                  {filteredSerialNumber?.map((serial, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={serialNumber.includes(String(serial))}
                            onChange={() => {
                              handleFilterSelection(
                                String(serial),
                                'serialNumber',
                              );
                            }}
                          />
                        }
                        label={serial}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>

          {/* <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Serial Number</p>
            <TextField
              id="searialName"
              className="manufacture_filter-searial"
              value={serialNumber}
              onChange={(e) => setSerialNumber(e.target.value)}
            />
          </div> */}

          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Category</p>
            <Select
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              displayEmpty
              value={dealerCategory}
              onClose={handleGetCategory}
              renderValue={() => {
                if (dealerCategory.length === 0) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Category
                    </span>
                  );
                }
                return dealerCategory.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search Category"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={handleCategorySearch}
                  />
                </div>
                <div className="selectoption_list_content">
                  {filteredCategory?.map((category, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={dealerCategory.includes(String(category))}
                            onChange={() => {
                              handleFilterSelection(
                                String(category),
                                'category',
                              );
                            }}
                          />
                        }
                        label={category}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>
          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Subcategory</p>
            <Select
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              displayEmpty
              disabled={filterStoreSubCategory?.length == 0}
              value={dealerSubcategory}
              onClose={handleGetSubCategory}
              renderValue={() => {
                if (dealerSubcategory.length === 0) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Subcategory
                    </span>
                  );
                }
                return dealerSubcategory.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search Subcategory"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={handleSubCategorySearch}
                  />
                </div>
                <div className="selectoption_list_content">
                  {filteredSubCategory?.map((subCategory, index) => (
                    <div key={index} className="selectoption_list">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={dealerSubcategory.includes(
                              String(subCategory),
                            )}
                            onChange={() => {
                              handleFilterSelection(
                                String(subCategory),
                                'subCategory',
                              );
                            }}
                          />
                        }
                        label={subCategory}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Select>
          </div>
        </div>
      </div>
      <div className="create_controller-nodata_drawer_button_content">
        <div className="create_controller-nodata_drawer_button">
          <Button
            variant="text"
            className="cencel_button"
            onClick={fliterCloseDrawer}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            className={
              isFilterActive ? 'save_button' : 'save_button disabled_button'
            }
            disabled={!isFilterActive}
          >
            Apply
          </Button>
        </div>
      </div>
    </div>
  );
};

const MemoizedComponent = React.memo(FilterDrawer);
export default MemoizedComponent;
